// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610062205/js/" + chunkId + "." + {"44":"877b6220","225":"06b09fb1","481":"0449dfe8","486":"7384da4b","770":"27b7f0d6"}[chunkId] + ".0.07990407604691796.chunk.js";
};